export default __webpack_public_path__ + "static/desk-property003-b51074f5e5be257355ed9c18f91f0a84.png";